import { IconFileDocument, IconFilePDF, IconFileSpreadsheet, IconFilePresentation, IconFileImage, IconFileAudio, IconFileVideo, IconDocumentFilled } from '@hubble/icons/web';
import 'react';
import { DOCUMENT_EXTENSIONS, PDF_EXTENSIONS, STYLESHEET_EXTENSIONS, PRESENTATION_EXTENSIONS, IMAGE_EXTENSIONS, AUDIO_EXTENSIONS, VIDEO_EXTENSIONS } from './constants.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { getColor } from '../utils/themeUtils.js';
import { Colors } from '../primitives/color.js';

const getReadableFileSize = size => {
  const MEGABYTE = 1000000;
  if (size < MEGABYTE) return `${size / 1000}KB`;else return `${size / MEGABYTE}MB`;
};
const composeKey = file => `${file.name}-${file.size}-${file.type}`;
const isStoredFile = file => Boolean(file === null || file === void 0 ? void 0 : file.url);
const needsToBeUploaded = (file, error) => !isStoredFile(file) && !error;
const ICONS_INFO = theme => [{
  extensions: DOCUMENT_EXTENSIONS,
  icon: jsx(IconFileDocument, {
    color: getColor(Colors.blue[600], Colors.blue[100])(theme)
  }),
  color: getColor(Colors.blue[100], Colors.blue[800])(theme)
}, {
  extensions: PDF_EXTENSIONS,
  icon: jsx(IconFilePDF, {
    color: getColor(Colors.red[600], Colors.red[100])(theme)
  }),
  color: getColor(Colors.red[100], Colors.red[800])(theme)
}, {
  extensions: STYLESHEET_EXTENSIONS,
  icon: jsx(IconFileSpreadsheet, {
    color: getColor(Colors.green[600], Colors.green[100])(theme)
  }),
  color: getColor(Colors.green[100], Colors.green[800])(theme)
}, {
  extensions: PRESENTATION_EXTENSIONS,
  icon: jsx(IconFilePresentation, {
    color: getColor(Colors.orange[600], Colors.orange[100])(theme)
  }),
  color: getColor(Colors.orange[100], Colors.orange[800])(theme)
}, {
  extensions: IMAGE_EXTENSIONS,
  icon: jsx(IconFileImage, {
    color: getColor(Colors.purple[600], Colors.purple[100])(theme)
  }),
  color: getColor(Colors.purple[100], Colors.purple[800])(theme)
}, {
  extensions: AUDIO_EXTENSIONS,
  icon: jsx(IconFileAudio, {
    color: getColor(Colors.purple[600], Colors.purple[100])(theme)
  }),
  color: getColor(Colors.purple[100], Colors.purple[800])(theme)
}, {
  extensions: VIDEO_EXTENSIONS,
  icon: jsx(IconFileVideo, {
    color: getColor(Colors.purple[600], Colors.purple[100])(theme)
  }),
  color: getColor(Colors.purple[100], Colors.purple[800])(theme)
}];
const DEFAULT_ICON_INFO = theme => ({
  icon: jsx(IconDocumentFilled, {
    color: getColor(Colors.black, Colors.white)(theme)
  }),
  color: getColor(Colors.gray[100], Colors.gray[800])(theme)
});

export { DEFAULT_ICON_INFO, ICONS_INFO, composeKey, getReadableFileSize, isStoredFile, needsToBeUploaded };
